// Axios
import { instance } from './axios.instance';

// Historique des états du content d'un document. Préfixes d'URL distincts
// proposal vs template, alignés sur requests/proposals.js (patchBox/patchStructure).
const versionsBase = (documentType, documentId) =>
  documentType === 'template'
    ? `/proposals/templates/${documentId}/versions`
    : `/proposal/${documentId}/versions`;

// Liste des versions (métadonnées seules, plus récent d'abord) :
// [{ id, reason, author_id, author_name, created_at, content_hash }]
export const getVersions = async ({ documentType, documentId }) => {
  const res = await instance.get(versionsBase(documentType, documentId));
  return res.data;
};

// Content ACTUEL persisté du document, au format stocké (même format que les
// versions) — pour diffé une version contre l'état courant. On lit le content
// brut renvoyé par l'endpoint show, sans le transform front (formatResContent).
export const getDocumentContent = async ({ documentType, documentId }) => {
  const url =
    documentType === 'template'
      ? `/proposals/templates/${documentId}`
      : `/proposal/${documentId}`;
  const res = await instance.get(url);
  return res.data?.content;
};

// Une version avec son content (Hash dézippé côté back) :
// { id, reason, author_id, author_name, created_at, content_hash, content }
export const getVersion = async ({ documentType, documentId, versionId }) => {
  const res = await instance.get(
    `${versionsBase(documentType, documentId)}/${versionId}`
  );
  return res.data;
};

// Restaure une version : le back snapshot l'état courant (reason before_restore)
// puis écrase le content. Renvoie { ok, content } — le content restauré à
// réappliquer au store côté front.
export const restoreVersion = async ({ documentType, documentId, versionId }) => {
  const res = await instance.post(
    `${versionsBase(documentType, documentId)}/${versionId}/restore`
  );
  return res.data;
};

// Renomme une version (label libre saisi par l'utilisateur). label vide = effacer.
export const renameVersion = async ({
  documentType,
  documentId,
  versionId,
  label,
}) => {
  const res = await instance.patch(
    `${versionsBase(documentType, documentId)}/${versionId}`,
    { label }
  );
  return res.data;
};
